import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

import Autocomplete from '@material-ui/lab/Autocomplete';

import { 
  Typography, 
  TextField, 
  MenuItem,
  Button,
  Switch
} from '@material-ui/core';


import DateFnsUtils from '@date-io/date-fns';
import krLocale from "date-fns/locale/ko";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import { find_device_statuses } from 'common/datas';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  rowIcons: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    //paddingLeft: theme.spacing(8),
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  // row1: {
  //   width: '240px',
  //   display: 'flex',
  //   alignItems: 'center',
  //   marginLeft: theme.spacing(6),
  //   '& > *': {
  //     marginLeft: theme.spacing(0),
  //     margin: theme.spacing(1),
  //   },
  // },
  // spacer: {
  //   flexGrow: 1
  // },
  // Button: {
  //   marginRight: theme.spacing(1)
  // },
  // exportButton: {
  //   marginRight: theme.spacing(1)
  // },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  find_date_title: {
    marginLeft: theme.spacing(2),
    width: '60px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
}));

const CarToolbar = props => {

  const { 
    className, 
    companies,
    cars,
    onClickSearch,
    ...rest
 } = props;

  const classes = useStyles();

  const [selectedCompany, setSelectedCompany] = useState('');
  const [selectedTypeDevice, setSelectedTypeDevice] = useState('전체');

  const handleChangeTypeDevice = event => {
    setSelectedTypeDevice(event.target.value);
  };

  const [selectedCarNumber, setSelectedCarNumber] = useState('');

  const [selected_date_on, set_selected_date_on] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());

  const handleStartDateChange = date => {
    setSelectedStartDate(date);
  };

  const handleEndDateChange = date => {
    setSelectedEndDate(date);
  };


  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
        <Typography
          className={classes.registerListItemTitle}
          color="textSecondary"
          gutterBottom
        >
          택시회사 명
        </Typography>

        <Autocomplete
          id="car-toobar-find-company-name-auto"
          options={companies.map(company => company.name)}
          style={{ width: 240 }}
          value={selectedCompany}
          onChange={(event, newValue) => {
            //console.log(newValue);
            setSelectedCompany(newValue);
          }}
          // onChange={event=> setSelectedCompany(event.target.value)}
          renderInput={params => (
            <TextField {...params} 
              //variant="outlined" 
              fullWidth 
              margin="dense" />
          )}
        />

        <Typography
          className={classes.registerListItemTitle}
          color="textSecondary"
          gutterBottom
        >
          디바이스상태
        </Typography>

        <TextField
          className={classes.registerListItemInput}
          id="outlined-select-agency"
          select
          value={selectedTypeDevice}
          onChange={handleChangeTypeDevice}
          helperText=""
          //variant="outlined"
          margin="dense"
        >
          {find_device_statuses.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        
       <Button
        color="primary"
        variant="contained"
        onClick={ () => onClickSearch(
          selectedCompany, 
          selectedTypeDevice, 
          selectedCarNumber, 
          selected_date_on ? selectedStartDate : null, 
          selected_date_on ? selectedEndDate : null) }
       >
         조회
       </Button>
       
      </div>

      <div className={classes.row}>

        <Typography
          className={classes.registerListItemTitle}
          color="textSecondary"
          gutterBottom
        >
          차량번호
        </Typography>

        <Autocomplete
          id="car-toolbar-car-name-auto"
          options={cars.map(car => car.number)}
          style={{ width: 240 }}
          value={selectedCarNumber}
          onChange={(event, newValue) => {
            //console.log(newValue);
            setSelectedCarNumber(newValue);
          }}
          // onChange={event=> setSelectedCompany(event.target.value)}
          renderInput={params => (
            <TextField {...params} 
              //variant="outlined" 
              fullWidth 
              margin="dense" />
          )}
        />

      </div>

      <div className={classes.row}>
        <Typography
          className={classes.find_date_title}
          color="textSecondary"
          gutterBottom
        >
          장착일
        </Typography>

        <Switch
          checked={selected_date_on}
          onChange={e => set_selected_date_on(e.target.checked)}
          // name="checkedA"
          inputProps={{ 'aria-label': 'secondary checkbox' }}
        />

        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={krLocale}>
          <KeyboardDatePicker
            disableToolbar
            variant="inline"
            format="yyyy-MM-dd"
            margin="dense"
            id="install-start-date-picker-inline"
            value={selectedStartDate}
            onChange={handleStartDateChange}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
          />
          <Typography
            className={classes.registerListItemDateGap}
            color="textSecondary"
            gutterBottom
          >
            ~
          </Typography>
          <KeyboardDatePicker
            disableToolbar
            variant="inline"
            format="yyyy-MM-dd"
            margin="dense"
            id="install-end-date-picker-inline"
            value={selectedEndDate}
            onChange={handleEndDateChange}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
          />
        </MuiPickersUtilsProvider>
      </div>

    </div>
  );
};

CarToolbar.propTypes = {
  className: PropTypes.string,
  companies: PropTypes.array.isRequired,
//  car_numbers: PropTypes.array.isRequired
};

CarToolbar.defaultProps = {
  companies: [],
//  car_numbers: []
};

export default CarToolbar;
